const makeId = (n) =>
{
	return Array(n)
		.fill(null)
		.map(() => Math.random() * 100 % 25 + 'A'.charCodeAt(0))
		.map(a => String.fromCharCode(a))
		.join('');
}

export const generateMockDefinitions = (definitionsType) =>
{
	let mockDefs = {};
	for (let i = 0; i < 50; i++)
	{
		let hash = String(Math.floor(Math.random() * 1000000000));
		let def = {
			hash,
			index: i
		}

		for (let j = 0; j < 6; j++)
		{
			def[makeId(8)] = makeId(20)
		}

		mockDefs[hash] = def;
	}

	return mockDefs;
}